import { RelatedProducts } from './Models/RelatedProducts';
import { StandardLink } from './Models/StandardLink';
import { ShortListProduct } from '../Shared/Models/ShortListProduct';
import { getImagePath } from '../Shared/ProductHelper';

/**
 * Enthält Logiken die für das Rendern der einzelner Produktinfos
 */
export class ProductInfoRenderer {
    /**
     * Gibt es Vor- bzw. Nachfolger werden diese geladen und angezeigt
     */
    RenderRelatedProducts() {
        var predecessorIds = null;
        var descandantId: any = 0;
        var productId = $('#productGoogleTracking').data('id');

        const isRedesignPage = $('.product-detailpage-rework').length > 0;

        if ($('#predecessorContainer').length) {
            predecessorIds = $('#predecessorContainer').data('id');
        }
        if ($('#descendantContainer').length) {
            descandantId = $('#descendantContainer').data('id');
        }
        if (descandantId > 0 || predecessorIds) {
            if (descandantId > 0 && !isRedesignPage) {
                $('.nachauflage_container').removeClass('hide'); //Spinner wird angezeigt
            }
            $.ajax({
                method: 'GET',
                dataType: 'JSON',
                url: `/Umbraco/api/ProduktdetailApi/GetRelatedProducts?productId=${productId}&predecessors=${
                    predecessorIds ? predecessorIds : ''
                }&descendant=${descandantId}`,
                success: data => {
                    const relatedProducts = data as RelatedProducts;

                    if (isRedesignPage) {
                        this.createRelatedProductsHtmlRedesign(relatedProducts);
                        this.fillDescendantProductBoxRedesign(relatedProducts.descendantProduct);
                        this.fillPredecessorProductBoxRedesign(relatedProducts.predecessorProduct);
                    } else {
                        this.createRelatedProductsHtml(relatedProducts);
                        this.fillDescendantProductBox(relatedProducts.descendantProduct);
                    }
                },
                error: () => {
                    $('.relatedproducts.ajaxSpinner_Loading').addClass('hide');
                    $('.nachauflage_container').addClass('hide');
                },
            });
        }
    }

    private createRelatedProductsHtml(relatedProducts: RelatedProducts) {
        $('.relatedproducts.ajaxSpinner_Loading').addClass('hide');
        if (relatedProducts) {
            if (relatedProducts.descendantLink) {
                this.BuildRelatedProductClone(
                    relatedProducts.descendantLink,
                    'Nachauflage:',
                    $('#descendantContainer')
                );
            }
            if (relatedProducts.predecessorLinks && relatedProducts.predecessorLinks.length > 0) {
                var BuildRelatedProductClone = this.BuildRelatedProductClone;
                relatedProducts.predecessorLinks.forEach(function(link, index) {
                    BuildRelatedProductClone(link, index == 0 ? 'Vorauflage:' : '', $('#predecessorContainer'));
                });
            }
        }
    }

    private createRelatedProductsHtmlRedesign(relatedProducts: RelatedProducts) {
        $('.relatedproducts.ajaxSpinner_Loading').addClass('hide');

        if (
            !relatedProducts ||
            (!relatedProducts.descendantLink &&
                (!relatedProducts.predecessorLinks || relatedProducts.predecessorLinks.length === 0))
        ) {
            return;
        }

        $('#title-biseries-productinfo').removeClass('hide');

        if (relatedProducts.descendantProduct) {
            $('#descendantContainer').html(`
                    <p>
                        zur Nachauflage:
                        <a class="nachauflage_link" href="${relatedProducts.descendantLink.href}">
                             ${relatedProducts.descendantLink.displayName}
                        </a>
                    </p>
                        
                `);
        }
        if (relatedProducts.predecessorLinks && relatedProducts.predecessorLinks.length > 0) {
            relatedProducts.predecessorLinks.forEach(function(link, index) {
                $('#predecessorContainer').append(`
                        <p>zur Vorauflage:
                            <a class="nachauflage_link" href="${link.href}">
                                ${link.displayName}
                            </a> 
                        </p>
                    `);
            });
        }
    }

    private BuildRelatedProductClone(relatedProduct: StandardLink, preText: string, container: JQuery) {
        var descendantPrototype = $('#ProduktdetailPrototypes #relatedProductPrototype p').clone();
        descendantPrototype.find('span.preTextRelatedProduct').html(preText);
        descendantPrototype.find('span.txt').html(relatedProduct.displayName);
        descendantPrototype.find('a').attr('href', relatedProduct.href);
        container.append(descendantPrototype);
    }

    private async fillDescendantProductBox(product: ShortListProduct) {
        let nachauflage_container = $('.nachauflage_container');

        if (!product) {
            nachauflage_container.addClass('hide');
            return;
        }

        var imagePath = await getImagePath(product.hasProduktabbildung ? product.productId : -1, 50);
        if (!product.hasProduktabbildung) {
            imagePath = `${imagePath.split('?')[0]}?width=60&height=50&quality=80`;
        }

        nachauflage_container.find('img').attr('src', imagePath);

        nachauflage_container.find('.authorlist').html(product.authorList);
        nachauflage_container.find('.haupttitel').html(product.titleMain);
        if (product.edition) {
            if (product.publicationYear) {
                nachauflage_container.find('.bibData').html(`${product.edition} ${product.publicationYear}`);
            } else {
                nachauflage_container.find('.bibData').html(`${product.edition}`);
            }
        } else {
            nachauflage_container.find('.bibData').html(`${product.publicationYear}`);
        }
        nachauflage_container
            .find('.nachauflage_link')
            .attr('href', `/${product.seoOptimizedUrlPart}/product/${product.productId}`);
        nachauflage_container.find('.ajaxSpinner_Loading').addClass('hide');
        nachauflage_container.find('.nachauflage_box').removeClass('hide');
    }

    private async fillDescendantProductBoxRedesign(product: ShortListProduct) {
        const nachauflage_container = $('.nachauflage_container');

        $('.nachauflage_container').removeClass('hide');

        if (!product) {
            nachauflage_container.addClass('hide');
            return;
        }

        const linkText = product.edition ? `zur Nachauflage (${product.edition})` : 'zur Nachauflage';
        nachauflage_container
            .find('.nachauflage_link')
            .attr('href', `/${product.seoOptimizedUrlPart}/product/${product.productId}`)
            .text(linkText);
        nachauflage_container.find('.ajaxSpinner_Loading').addClass('hide');
        nachauflage_container.find('.nachauflage_box').removeClass('hide');
    }

    private fillPredecessorProductBoxRedesign(predecessorProduct: ShortListProduct) {
        const vorauflage_container = $('.vorauflage_container');

        if (!predecessorProduct) {
            return;
        }

        vorauflage_container.removeClass('hide');

        const linkText = predecessorProduct.edition
            ? `zur Vorauflage (${predecessorProduct.edition})`
            : 'zur Vorauflage';
        vorauflage_container
            .find('.vorauflage_link')
            .attr('href', `/${predecessorProduct.seoOptimizedUrlPart}/product/${predecessorProduct.productId}`)
            .text(linkText);
        vorauflage_container.find('.ajaxSpinner_Loading').addClass('hide');
        vorauflage_container.find('.vorauflage_box').removeClass('hide');
    }
}
